<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Etapa" v-if="eventoEtapaHabilitada">
          <app-evento-etapa
            label="Etapa"
            :nombre="eventoEtapaNombre"
            :labelCols="labelCols"
            :valido="eventoEtapaValido"
            :lista="eventoEtapasList"
            :msjInvalido="eventoEtapaInvalidoMsj"
            @validate="validate"
            @updated="eventoEtapaActualizado">
          </app-evento-etapa>  
        </b-card>

        <b-card header="Código de Promoción" v-if="eventoSolicitaCodigoPromocion">
          <b-form>
            <b-form-group
              label="Código"
              label-for="codigoPromocion"
              :label-cols="labelCols"
              description="Código de identificación, Id, código de promoción"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="validarCodigoPromocion">
                  <b-input-group-text>
                    <i class="fa fa-check"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="codigoPromocion"
                  v-model.trim="$v.codigoPromocion.$model" 
                  :state="codigoPromocionValido"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-invalid-feedback id="codigoPromocionFeedback">
                  {{ codigoPromocionInvalidoMsj }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>

            <b-alert
              class="alert"
              :show="dismissCountDown"
              dismissible
              fade
              :variant="alertVariant"
              @dismissed="dismissCountDown= 0"
              @dismiss-count-down="countDownChanged">
              <p>{{ alertMsj }}</p>
            </b-alert>
          </b-form>
        </b-card>

        <b-card header="Sorteo" v-if="eventoImportaGanadores">
          <b-form>
            <b-form-group
              label="Posición"
              label-for="posicionSorteo"
              :label-cols="labelCols"
              description="Posición en el sorteo"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="posicionSorteo"
                  :value="posicionSorteo" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-form>
          <template slot="footer">
            <small class="text-muted">Sorteo importado a partir de un archivo CSV</small>
          </template>  
        </b-card>

        <b-card header= "Información del Participante">
          <b-form>
            <b-form-group
              v-if="eventoSolicitaNombre"
              label="Apellido"
              label-for="apellido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="apellido"
                v-model.trim="$v.apellido.$model" 
                :state="apellidoValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="apellidoFeedback">
                {{ apellidoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaNombre"
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              v-if="!eventoWhapp"
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                :value="documentoNumero" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->

            <!-- <b-form-group
              label="Pais"
              label-for="pais"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pais"
                :value="pais" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->

            <b-form-group
              v-if="eventoSolicitaDocumento"
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDatosPersonales"
              label="Fecha de Nacimiento"
              label-for="fechaNacimiento"
              :label-cols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="fechaNacimientoHabilitada"
                      v-model="fechaNacimientoHabilitada"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="fechaNacimiento" 
                  v-model="$v.fechaNacimiento.$model" 
                  type="date"
                  :disabled= "fechaNacimientoDisabled"
                  :state="fechaNacimientoValida"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="fechaNacimientoFeedback">
                {{ fechaNacimientoInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-genero
              v-if="eventoSolicitaDatosPersonales"
              label="Género"
              :nombre="sexo"
              :labelCols="labelCols"
              :valido="generoValido"
              :lista="generosList"
              :msjInvalido="generoInvalidoMsj"
              @validate="validate"
              @updated="generoActualizado">
            </app-genero>  

            <div 
              v-if="eventoSolicitaTelefono"
              class="grupo-controles">
              <b-form-group
                label="Nro Celular"
                label-for="nroCelular"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="prefijo"
                  v-model.trim="$v.prefijo.$model" 
                  :state="prefijoValido"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-input 
                  id="celular"
                  v-model.trim="$v.celular.$model" 
                  :state="celularValido"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-invalid-feedback id="nroCelularFeedback">
                  {{ nroCelularInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-form-group>
            </div>

            <b-form-group
              v-if="eventoSolicitaEmail"
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <br>

            <app-pais
              v-if="eventoSolicitaUbicacion"
              label="Pais"
              :nombre="paisNombre"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="paisValido"
              :lista="paisesList"
              :msjInvalido="paisInvalidoMsj"
              @validate="validate"
              @updated="paisActualizado">
            </app-pais>

            <app-provincia
              v-if="eventoSolicitaUbicacion"
              label="Provincia"
              :nombre="provinciaNombre"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="provinciaValida"
              :lista="provinciasList"
              :msjInvalido="provinciaInvalidaMsj"
              @validate="validate"
              @updated="provinciaActualizada">
            </app-provincia>

            <app-localidad
              v-if="eventoSolicitaLocalidad"
              label="Localidad"
              :nombre="localidadNombre"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="localidadValida"
              :lista="localidadesList"
              :msjInvalido="localidadInvalidaMsj"
              @validate="validate"
              @updated="localidadActualizada">
            </app-localidad>

            <b-form-group
              v-if="eventoSolicitaBarrio"
              label="Barrio"
              label-for="barrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="barrio"
                v-model.trim="$v.barrio.$model" 
                :state="barrioValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="barrioFeedback">
                {{ barrioInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Calle"
              label-for="direccionCalle"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccionCalle"
                v-model.trim="$v.direccionCalle.$model" 
                :state="direccionCalleValida"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionCalleFeedback">
                {{ direccionCalleInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Número"
              label-for="direccionNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccionNumero"
                v-model.trim="$v.direccionNumero.$model" 
                :state="direccionNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionNumeroFeedback">
                {{ direccionNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacion"
              label="Cod.Postal"
              label-for="codigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPostal"
                v-model.trim="$v.codigoPostal.$model" 
                :state="codigoPostalValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="codigoPostalFeedback">
                {{ codigoPostalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoValidaNumeroCliente"
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="clientePrevio"
                      v-model="clientePrevio"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="numeroCliente" 
                  v-model="$v.numeroCliente.$model" 
                  type="text"
                  :disabled="numeroClienteDisabled"
                  :state="numeroClienteValido"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="numeroClienteFeedback">
                {{ numeroClienteInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header= "Información Bancaria" v-if="eventoRequiereInformacionBancaria">
          <b-form>
            <app-banco
              label="Banco"
              :nombre="bancoNombre"
              :labelCols="labelCols"
              :valido="bancoValido"
              :lista="bancosList"
              :msjInvalido="bancoInvalidoMsj"
              @validate="validate"
              @updated="bancoActualizado">
            </app-banco>

            <b-form-group
              label="CBU"
              label-for="cbu"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbu"
                v-model.trim="$v.cbu.$model" 
                :state="cbuValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuFeedback">
                {{ cbuInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU Alias"
              label-for="cbuAlias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbuAlias"
                v-model.trim="$v.cbuAlias.$model" 
                :state="cbuAliasValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuAliasFeedback">
                {{ cbuAliasInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Titular"
              label-for="titularCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuenta"
                v-model.trim="$v.titularCuenta.$model" 
                :state="titularCuentaValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="titularCuentaFeedback">
                {{ titularCuentaInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CUIT"
              label-for="titularCuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuit"
                v-model.trim="$v.titularCuit.$model" 
                :state="titularCuitValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="titularCuitFeedback">
                {{ titularCuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header= "Información del Negocio" v-if="eventoParticipacionNegocios">
          <b-form>
            <b-form-group
              v-if="eventoSolicitaPosicionNegocio"
              label="Posición"
              label-for="posicion"
              :label-cols="labelCols"
              description="Posición, puesto o cargo del participante"
              horizontal>
              <b-form-input 
                id="posicion"
                v-model.trim="$v.posicion.$model" 
                :state="posicionValida"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="posicionFeedback">
                {{ posicionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                v-model.trim="$v.nombreComercial.$model" 
                :state="nombreComercialValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreComercialFeedback">
                {{ nombreComercialInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaRazonSocialNegocio"
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                v-model.trim="$v.razonSocial.$model" 
                :state="razonSocialValida"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="razonSocialFeedback">
                {{ razonSocialInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaDocumentoNegocio"
              label="CUIT"
              label-for="cuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuit"
                v-model.trim="$v.cuit.$model" 
                :state="cuitValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuitFeedback">
                {{ cuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-negocio-pais
              v-if="eventoSolicitaUbicacionNegocio"
              label="Pais"
              :nombre="negocioPaisNombre"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="negocioPaisValido"
              :lista="negocioPaisesList"
              :msjInvalido="negocioPaisInvalidoMsj"
              @validate="validate"
              @updated="negocioPaisActualizado">
            </app-negocio-pais>

            <app-negocio-provincia
              v-if="eventoSolicitaUbicacionNegocio"
              label="Provincia"
              :nombre="negocioProvinciaNombre"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="negocioProvinciaValida"
              :lista="negocioProvinciasList"
              :msjInvalido="negocioProvinciaInvalidaMsj"
              @validate="validate"
              @updated="negocioProvinciaActualizada">
            </app-negocio-provincia>

            <app-negocio-localidad
              v-if="eventoSolicitaLocalidadNegocio"
              label="Localidad"
              :nombre="negocioLocalidadNombre"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="negocioLocalidadValida"
              :lista="negocioLocalidadesList"
              :msjInvalido="negocioLocalidadInvalidaMsj"
              @validate="validate"
              @updated="negocioLocalidadActualizada">
            </app-negocio-localidad>

            <b-form-group
              v-if="eventoSolicitaBarrioNegocio"
              label="Barrio"
              label-for="negocioBarrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioBarrio"
                v-model.trim="$v.negocioBarrio.$model" 
                :state="negocioBarrioValido"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="negocioBarrioFeedback">
                {{ negocioBarrioInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Calle"
              label-for="negocioDireccionCalle"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioDireccionCalle"
                v-model.trim="$v.negocioDireccionCalle.$model" 
                :state="negocioDireccionCalleValida"
                type="text"
                class="text-upper"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="negocioDireccionCalleFeedback">
                {{ negocioDireccionCalleInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Número"
              label-for="negocioDireccionNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioDireccionNumero"
                v-model.trim="$v.negocioDireccionNumero.$model" 
                :state="negocioDireccionNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="negocioDireccionNumeroFeedback">
                {{ negocioDireccionNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaUbicacionNegocio"
              label="Cod.Postal"
              label-for="negocioCodigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioCodigoPostal"
                v-model.trim="$v.negocioCodigoPostal.$model" 
                :state="negocioCodigoPostalValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="negocioCodigoPostalFeedback">
                {{ negocioCodigoPostalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header= "Campos Adicionales" v-if="camposAdicionales.length != 0">
          <b-form>
            <!-- <template v-for="(campoAdicional, index) in camposAdicionales" :key="index"> -->
              <b-form-group
                v-for="(campoAdicional, index) in camposAdicionales" :key="index"
                :label="campoAdicional.campo"
                :label-for="'c' + campoAdicional.id.toString()"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  :id="'c' + campoAdicional.id.toString()"
                  v-model="campoAdicional.valor"
                  type="text"
                  class="text-upper"
                  @blur.native="validate">
                </b-form-input>
              </b-form-group>
            <!-- </template> -->
          </b-form>
        </b-card>

        <b-card header= "Información Adicional">
          <b-form>
            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              description="Información adicional de referencia (nro de ticket, etc)"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="3"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import EventoEtapa from '../shared/abmSelect.vue';
import Genero from '../shared/abmSelect.vue';
import Banco from '../shared/abmSelect.vue';
import Pais from '../shared/abmSelect.vue';
import NegocioPais from '../shared/abmSelect.vue';
import Provincia from '../shared/abmSelect.vue';
import NegocioProvincia from '../shared/abmSelect.vue';
import Localidad from '../shared/abmSelect.vue';
import NegocioLocalidad from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { msjAlert } from '../../mixins/msjAlert';
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'participante/getField',
  mutationType: 'participante/updateField',
});

export default {
  name: 'ParticipanteABM',
  components: {
    appEventoEtapa: EventoEtapa,
    appGenero: Genero,
    appBanco: Banco,
    appPais: Pais,
    appNegocioPais: NegocioPais,
    appProvincia: Provincia,
    appNegocioProvincia: NegocioProvincia,
    appLocalidad: Localidad,
    appNegocioLocalidad: NegocioLocalidad,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal,
    msjAlert
  ],
  data () {
    return {
      eventoId: 0,

      noValidar: true,
      eventoEtapaValido: null,
      eventoEtapaInvalidoMsj: null,

      codigoPromocionValido: null,
      codigoPromocionInvalidoMsj: '',

      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      fechaNacimientoValida: null,
      fechaNacimientoInvalidaMsj: '',
      generoValido: null,
      generoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',

      prefijoValido: null,
      celularValido: null,
      nroCelularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',

      paisValido: null,
      paisInvalidoMsj: '',
      provinciaValida: null,
      provinciaInvalidaMsj: '',
      localidadValida: null,
      localidadInvalidaMsj: '',
      barrioValido: null,
      barrioInvalidoMsj: '',
      direccionCalleValida: null,
      direccionCalleInvalidaMsj: '',
      direccionNumeroValido: null,
      direccionNumeroInvalidoMsj: '',
      codigoPostalValido: null,
      codigoPostalInvalidoMsj: '',

      bancoValido: null,
      bancoInvalidoMsj: '',
      cbuValido: null,
      cbuInvalidoMsj: '',
      cbuAliasValido: null,
      cbuAliasInvalidoMsj: '',
      titularCuentaValido: null,
      titularCuentaInvalidoMsj: '',
      titularCuitValido: null,
      titularCuitInvalidoMsj: '',

      posicionValida: null,
      posicionInvalidaMsj: '',
      nombreComercialValido: null,
      nombreComercialInvalidoMsj: '',
      razonSocialValida: null,
      razonSocialInvalidaMsj: '',
      cuitValido: null,
      cuitInvalidoMsj: '',
      negocioPaisValido: null,
      negocioPaisInvalidoMsj: '',
      negocioProvinciaValida: null,
      negocioProvinciaInvalidaMsj: '',
      negocioLocalidadValida: null,
      negocioLocalidadInvalidaMsj: '',
      negocioBarrioValido: null,
      negocioBarrioInvalidoMsj: '',
      negocioDireccionCalleValida: null,
      negocioDireccionCalleInvalidaMsj: '',
      negocioDireccionNumeroValido: null,
      negocioDireccionNumeroInvalidoMsj: '',
      negocioCodigoPostalValido: null,
      negocioCodigoPostalInvalidoMsj: '',

      numeroClienteValido: null,
      numeroClienteInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,

      fechaNacimientoDisabled: true,
      numeroClienteDisabled: true,

      generosList: [],
      bancos: [],
      bancosList: [],
      paises: [],
      paisesList: [],
      provincias: [],
      provinciasList: [],
      localidades: [],
      localidadesList: [],
      negocioPaises: [],
      negocioPaisesList: [],
      negocioProvincias: [],
      negocioProvinciasList: [],
      negocioLocalidades: [],
      negocioLocalidadesList: [],

      loading: false,
      loadingPaises: false,
      loadingNegocioPaises: false,
      loadingProvincias: false,
      loadingNegocioProvincias: false,
      loadingLocalidades: false,
      loadingNegocioLocalidades: false,
      loadingBancos: false,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'codigoPromocion',
      'apellido',
      'nombre',
      'documentoNumero',
      'fechaNacimiento',
      'fechaNacimientoHabilitada',
      'sexo',

      'prefijo',
      'celular',
      'email',

      'pais',
      'paisNombre',
      'provincia',
      'provinciaNombre',
      'localidad',
      'localidadNombre',
      'barrio',
      'direccionCalle',
      'direccionNumero',
      'codigoPostal',

      'banco',
      'bancoNombre',
      'cbu',
      'cbuAlias',
      'titularCuenta',
      'titularCuit',

      /* Datos del negocio */
      'posicion',
      'nombreComercial',
      'razonSocial',
      'cuit',
      'negocioPais',
      'negocioPaisNombre',
      'negocioProvincia',
      'negocioProvinciaNombre',
      'negocioLocalidad',
      'negocioLocalidadNombre',
      'negocioBarrio',
      'negocioDireccionCalle',
      'negocioDireccionNumero',
      'negocioCodigoPostal',

      'clientePrevio',
      'numeroCliente',

      'observaciones',

      'posicionSorteo',

      'camposAdicionales',

      'evento',
      // 'eventoWhapp',
      'eventoSolicitaCodigoPromocion',
      'eventoRequiereCodigoPromocion',
      'eventoSolicitaNombre',
      'eventoRequiereNombre',
      'eventoSolicitaDocumento',
      'eventoRequiereDocumento',
      'eventoSolicitaDatosPersonales',
      'eventoSolicitaTelefono',
      'eventoRequiereTelefono',
      'eventoSolicitaEmail',
      'eventoRequiereEmail',
      'eventoSolicitaUbicacion',
      'eventoRequiereUbicacion',
      'eventoSolicitaLocalidad',
      'eventoRequiereLocalidad',
      'eventoSolicitaBarrio',
      'eventoRequiereBarrio',
      'eventoRequiereInformacionBancaria',
      'eventoParticipacionNegocios',
      'eventoSolicitaPosicionNegocio',
      'eventoRequierePosicionNegocio',
      'eventoSolicitaRazonSocialNegocio',
      'eventoRequiereRazonSocialNegocio',
      'eventoSolicitaDocumentoNegocio',
      'eventoRequiereDocumentoNegocio',
      'eventoSolicitaUbicacionNegocio',
      'eventoRequiereUbicacionNegocio',
      'eventoSolicitaLocalidadNegocio',
      'eventoRequiereLocalidadNegocio',
      'eventoSolicitaBarrioNegocio',
      'eventoRequiereBarrioNegocio',
      'eventoValidaNumeroCliente',
      'eventoImportaGanadores',

      'eventoEtapa',
      'eventoEtapaNombre',
      'eventoEtapas',
      'eventoEtapasList'
    ]),
    eventoEtapaHabilitada() {
      if (this.id == 0) {
        /* En caso de altas de participantes valido la etapa */
        if (this.eventoEtapasList) {
          if (this.eventoEtapasList.length != 0) {
            return true;
          }
        }
      }

      return false;
    }
  },  
  created() {
    let participanteId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.id){
        participanteId = this.$route.params.id;
      }
    }

    let params = {
      eventoId: this.eventoId,
      participanteId
    }

    this.loadingPaises = true;
    this.loadingNegocioPaises = true;
    this.loadingProvincias = true;
    this.loadingNegocioProvincias = true;
    this.loadingLocalidades = true;
    this.loadingNegocioLocalidades = true;
    this.loadingBancos = true;
    this.showSpinner();
    this.$store.dispatch('participante/inicializar', params)
      .then(() => {
        if (moment(this.fechaNacimiento).format('YYYY-MM-DD') == '1900-01-01') {
          this.fechaNacimientoDisabled = true;
        } else {
          this.fechaNacimientoDisabled = false;
        }
        this.numeroClienteDisabled = !(/true/i).test(this.clientePrevio);
        
        this.getDatosAdicionales();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;

      if (!(/true/i).test(this.eventoWhapp)) {
        this.loading = true;

        if ((/true/i).test(this.eventoSolicitaDatosPersonales)) {
          this.$store.dispatch('generos/getList')
            .then(() => {
              vm.generosList = this.$store.getters['generos/list'];
              this.loading = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de géneros.'));        
        }

        if ((/true/i).test(this.eventoRequiereInformacionBancaria)) {
          this.$store.dispatch('bancos/getList')
            .then(() => {
              vm.bancos = this.$store.getters['bancos/list'];
              vm.bancosList = this.$store.getters['bancos/selectList'];
              vm.loadingBancos = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de bancos.'));        
        }

        this.$store.dispatch('paises/getList')
          .then(() => {
            let list = this.$store.getters['paises/list'];
            let selectList = this.$store.getters['paises/selectList'];

            vm.paises = [ ...list ];
            vm.paisesList = [ ...selectList ];

            vm.negocioPaises = [ ...list ];
            vm.negocioPaisesList = [ ...selectList ];

            vm.loadingPaises = false;
            vm.loadingNegocioPaises = false;
            return
          })
          .then(() => {
            this.getProvincias();
            this.getNegocioProvincias();
          })
          .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de paises.'));        

        this.$store.dispatch('provincias/getList')
          .then(() => {
            vm.provincias = this.$store.getters['provincias/list'];
            vm.provinciasList = this.$store.getters['provincias/selectList'];
          })
          .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
      }
    },
    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.paisNombre)
      {
        let pais = this.getSelected(this.paises, this.paisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .then (() => this.getLocalidades())
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    getLocalidades() {
      this.localidades = [];
      this.localidadesList = [];

      if ((/true/i).test(this.eventoSolicitaLocalidad)) {
        let provinciaId = 0;
        if (this.provincia) {
          if (this.provincia.id) {
            if (this.provincia.id != 0) {
              provinciaId = this.provincia.id;
            }
          }
        }
  
        if (provinciaId != 0)
        {
          this.$store.dispatch('localidades/getList', provinciaId)
            .then(() => {
              this.localidades = this.$store.getters['localidades/list'];
              this.localidadesList = this.$store.getters['localidades/selectList'];
              this.loadingLocalidades = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de localidades.'));
        }
      }
    },
    getNegocioProvincias() {
      this.negocioProvincias = [];
      this.negocioProvinciasList = [];

      if (this.negocioPaisNombre)
      {
        let pais = this.getSelected(this.negocioPaises, this.negocioPaisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.negocioProvincias = this.$store.getters['provincias/list']
              this.negocioProvinciasList = this.$store.getters['provincias/selectList']
              
              this.loadingNegocioProvincias = false;
            })
            .then (() => this.getNegocioLocalidades())
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    getNegocioLocalidades() {
      this.negocioLocalidades = [];
      this.negocioLocalidadesList = [];

      if ((/true/i).test(this.eventoSolicitaLocalidadNegocio)) {
        if (this.negocioProvinciaNombre)
        {
          var provincia = this.getSelected(this.negocioProvincias, this.negocioProvinciaNombre);
          if (provincia)
          {
            this.$store.dispatch('localidades/getList', provincia.id)
              .then(() => {
                this.negocioLocalidades = this.$store.getters['localidades/list'];
                this.negocioLocalidadesList = this.$store.getters['localidades/selectList'];
                this.loadingNegocioLocalidades = false;
              })
              .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de localidades.'));
          }
        }
      }
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false;
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj= 'Debe ingresar el número de documento.';
          } else if (!this.$v.documentoNumero.maxLength) {
            this.documentoNumeroInvalidoMsj = 'El número de documento solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj= 'Debe ingresar el apellido del participante.';
          } else if (!this.$v.nombre.maxLength) {
            this.apellidoInvalidoMsj = 'El apellido solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del participante.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      let prefijoEmpty = false;
      let celularEmpty = false;

      if (campo == 'prefijo' || validarTodos) {
        if (this.$v.prefijo.$error) {
          this.prefijoValido = false;
          if (!this.$v.prefijo.required) {
            prefijoEmpty = true;
          } else if (!this.$v.prefijo.numeric) {

          } 
        } else {
          this.prefijoValido = null;
        }
      }

      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.required) {
            celularEmpty = true;
          } else if (!this.$v.celular.numeric) {

          } 
        } else {
          this.celularValido = null;
        }
      }

      if (this.prefijoValido == false || this.celularValido == false) {
        if (prefijoEmpty || celularEmpty) {
          this.nroCelularInvalidoMsj = 'El número de prefijo y celular son campos obligatorios.';
        } else {
          this.nroCelularInvalidoMsj = 'El número o prefijo de celular ingresado no es válido.';
        }
      } else {
        this.nroCelularInvalidoMsj = '';
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false;
          if (!this.$v.email.required) {
            this.emailInvalidoMsj = 'La dirección de correo electrónico es un campo obligatorio';
          } else if (!this.$v.email.email) {
            this.emailInvalidoMsj= 'La dirección de correo electrónico no parece ser válida.';
          } 
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }

      if (campo == 'barrio' || validarTodos) {
        if (this.$v.barrio.$error) {
          this.barrioValido = false;
          if (!this.$v.barrio.required) {
            this.barrioInvalidoMsj = 'El barrio es un campo obligatorio';
          } else if (!this.$v.barrio.maxLength) {
            this.barrioInvalidoMsj = 'El barrio solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.barrioValido = null;
          this.barrioInvalidoMsj = '';
        }
      }

      if (campo == 'direccionCalle' || validarTodos) {
        if (this.$v.direccionCalle.$error) {
          this.direccionCalleValida = false;
          if (!this.$v.direccionCalle.required) {
            this.direccionCalleInvalidaMsj = 'La dirección es un campo obligatorio';
          } else if (!this.$v.direccionCalle.maxLength) {
            this.direccionCalleInvalidaMsj = 'El dirección solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.direccionCalleValida = null;
          this.direccionCalleInvalidaMsj = '';
        }
      }

      if (campo == 'direccionNumero' || validarTodos) {
        if (this.$v.direccionNumero.$error) {
          this.direccionNumeroValido = false;
          if (!this.$v.direccionNumero.required) {
            this.direccionNumeroInvalidoMsj = 'El número de la dirección es un campo obligatorio';
          } else if (!this.$v.direccionNumero.numeric) {
            this.direccionNumeroInvalidoMsj = 'El número de la dirección no es válido';
          } 
        } else {
          this.direccionNumeroValido = null;
          this.direccionNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'codigoPostal' || validarTodos) {
        if (this.$v.codigoPostal.$error) {
          this.codigoPostalValido = false;
          if (!this.$v.codigoPostal.required) {
            this.codigoPostalInvalidoMsj = 'El codigo postal es un campo obligatorio';
          } else if (!this.$v.codigoPostal.maxLength) {
            this.codigoPostalInvalidoMsj = 'El codigo postal solo puede contener hasta 10 caracteres';
          } 
        } else {
          this.codigoPostalValido = null;
          this.codigoPostalInvalidoMsj = '';
        }
      }

      if (campo == 'cbu' || campo == 'cbuAlias' || validarTodos) {
        if (this.$v.cbu.$error) {
          this.cbuValido = false;
          if (!this.$v.cbu.required) {
            this.cbuInvalidoMsj = 'Debe ingresar el CBU o el Alias del mismo';
          } else if (!this.$v.cbu.maxLength) {
            this.cbuInvalidoMsj = 'El CBU solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.cbuValido = null;
          this.cbuInvalidoMsj = '';
        }

        if (this.$v.cbuAlias.$error) {
          this.cbuAliasValido = false;
          if (!this.$v.cbuAlias.required) {
            this.cbuAliasInvalidoMsj = 'Debe ingresar el CBU o el Alias del mismo';
          } else if (!this.$v.cbuAlias.maxLength) {
            this.cbuAliasInvalidoMsj = 'El Alias del CBU solo puede contener hasta 150 caracteres';
          } 
        } else {
          this.cbuAliasValido = null;
          this.cbuAliasInvalidoMsj = '';
        }
      }

      if (campo == 'titularCuenta' || validarTodos) {
        if (this.$v.titularCuenta.$error) {
          this.titularCuentaValido = false;
          if (!this.$v.titularCuenta.required) {
            this.titularCuentaInvalidoMsj = 'El nombre del titular de la cuenta es un campo obligatorio';
          } else if (!this.$v.titularCuenta.maxLength) {
            this.titularCuentaInvalidoMsj = 'El nombre del titular de la cuenta solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.titularCuentaValido = null;
          this.titularCuentaInvalidoMsj = '';
        }
      }

      if (campo == 'titularCuit' || validarTodos) {
        if (this.$v.titularCuit.$error) {
          this.titularCuitValido = false;
          if (!this.$v.titularCuit.required) {
            this.titularCuitInvalidoMsj = 'El CUIT del titular de la cuenta es un campo obligatorio';
          } else if (!this.$v.titularCuit.maxLength) {
            this.titularCuitInvalidoMsj = 'El CUIT del titular de la cuenta solo puede contener hasta 15 caracteres';
          } 
        } else {
          this.titularCuitValido = null;
          this.titularCuitInvalidoMsj = '';
        }
      }

      if (campo == 'posicion' || validarTodos) {
        if (this.$v.posicion.$error) {
          this.posicionValida = false;
          if (!this.$v.posicion.required) {
            this.posicionInvalidaMsj= 'Debe ingresar la posición del participante.';
          } else if (!this.$v.posicion.maxLength) {
            this.posicionInvalidaMsj = 'La posición solo puede contener hasta 150 caracteres';
          } 
        } else {
          this.posicionValida = null;
          this.posicionInvalidaMsj = '';
        }
      }

      if (campo == 'nombreComercial' || validarTodos) {
        if (this.$v.nombreComercial.$error) {
          this.nombreComercialValido = false;
          if (!this.$v.nombreComercial.required) {
            this.nombreComercialInvalidoMsj= 'Debe ingresar el nombre comercial o la razón social del negocio';
          } else if (!this.$v.nombreComercial.maxLength) {
            this.nombreComercialInvalidoMsj = 'El nombre comercial solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.nombreComercialValido = null;
          this.nombreComercialInvalidoMsj = '';
        }
      }

      if (campo == 'razonSocial' || validarTodos) {
        if (this.$v.razonSocial.$error) {
          this.razonSocialValida = false;
          if (!this.$v.razonSocial.required) {
            this.razonSocialInvalidaMsj= 'Debe ingresar el nombre comercial o la razón social del negocio';
          } else if (!this.$v.razonSocial.maxLength) {
            this.razonSocialInvalidaMsj = 'La razón social solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.razonSocialValida = null;
          this.razonSocialInvalidaMsj = '';
        }
      }

      if (campo == 'cuit' || validarTodos) {
        if (this.$v.cuit.$error) {
          this.cuitValido = false;
          if (!this.$v.cuit.required) {
            this.cuitInvalidoMsj= 'Debe ingresar el CUIT del negocio.';
          } else if (!this.$v.cuit.maxLength) {
            this.cuitInvalidoMsj = 'El CUIT solo puede contener hasta 15 caracteres';
          } 
        } else {
          this.cuitValido = null;
          this.cuitInvalidoMsj = '';
        }
      }

      if (campo == 'negocioBarrio' || validarTodos) {
        if (this.$v.negocioBarrio.$error) {
          this.negocioBarrioValido = false;
          if (!this.$v.negocioBarrio.required) {
            this.negocioBarrioInvalidoMsj = 'El barrio del negocio es un campo obligatorio';
          } else if (!this.$v.negocioBarrio.maxLength) {
            this.negocioBarrioInvalidoMsj = 'El barrio solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.negocioBarrioValido = null;
          this.negocioBarrioInvalidoMsj = '';
        }
      }

      if (campo == 'negocioDireccionCalle' || validarTodos) {
        if (this.$v.negocioDireccionCalle.$error) {
          this.negocioDireccionCalleValida = false;
          if (!this.$v.negocioDireccionCalle.required) {
            this.negocioDireccionCalleInvalidaMsj = 'La dirección del negocio es un campo obligatorio';
          } else if (!this.$v.negocioDireccionCalle.maxLength) {
            this.negocioDireccionCalleInvalidaMsj = 'La dirección solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.negocioDireccionCalleValida = null;
          this.negocioDireccionCalleInvalidaMsj = '';
        }
      }

      if (campo == 'negocioDireccionNumero' || validarTodos) {
        if (this.$v.negocioDireccionNumero.$error) {
          this.negocioDireccionNumeroValido = false;
          if (!this.$v.negocioDireccionNumero.numeric) {
            this.negocioDireccionNumeroInvalidoMsj = 'El número de la dirección no es válido';
          } 
        } else {
          this.negocioDireccionNumeroValido = null;
          this.negocioDireccionNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'negocioCodigoPostal' || validarTodos) {
        if (this.$v.negocioCodigoPostal.$error) {
          this.negocioCodigoPostalValido = false;
          if (!this.$v.negocioCodigoPostal.required) {
            this.negocioCodigoPostalInvalidoMsj = 'El codigo postal del negocio es un campo obligatorio';
          } else if (!this.$v.negocioCodigoPostal.maxLength) {
            this.negocioCodigoPostalInvalidoMsj = 'El codigo postal solo puede contener hasta 10 caracteres';
          } 
        } else {
          this.negocioCodigoPostalValido = null;
          this.negocioCodigoPostalInvalidoMsj = '';
        }
      }

      if (campo == 'codigoPromocion' || validarTodos) {
        if (this.$v.codigoPromocion.$error) {
          this.codigoPromocionValido = false;
          if (!this.$v.codigoPromocion.required) {
            this.codigoPromocionInvalidoMsj= 'Debe ingresar el código de promoción.';
          } else if (!this.$v.codigoPromocion.maxLength) {
            this.codigoPromocionInvalidoMsj = 'El código de promoción solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.codigoPromocionValido = null;
          this.codigoPromocionInvalidoMsj = '';
        }
      }

      if (campo == 'numeroCliente' || validarTodos) {
        if (this.$v.numeroCliente.$error) {
          this.numeroClienteValido = false;
          if (!this.$v.numeroCliente.maxLength) {
            this.numeroClienteInvalidoMsj = 'El número de cliente solo puede contener hasta 20 caracteres';
          } 
        } else {
          this.numeroClienteValido = null;
          this.numeroClienteInvalidoMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          } 
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if ( (/true/i).test(this.eventoEtapaHabilitada)) {
        let errorEventoEtapa = true;
        if (this.eventoEtapa) {
          if (this.eventoEtapa.id) {
            if (this.eventoEtapa.id != 0) {
              errorEventoEtapa = false;
            }
          }
        }
        if (errorEventoEtapa) {
          save = false;
          this.eventoEtapaValido = false;
          this.eventoEtapaInvalidoMsj = 'Debe seleccionar la etapa correspondiente.';
        }
      }

      if ( (/true/i).test(this.eventoRequiereUbicacion)) {
        let errorPais = true;
        if (this.pais) {
          if (this.pais.id) {
            if (this.pais.id != 0) {
              errorPais = false;
            }
          }
        }
        if (errorPais) {
          save = false;
          this.paisValido = false;
          this.paisInvalidoMsj = 'Debe seleccionar el pais correspondiente.';
        }

        let errorProvincia = true;
        if (this.provincia) {
          if (this.provincia.id) {
            if (this.provincia.id != 0) {
              errorProvincia = false;
            }
          }
        }
        if (errorProvincia) {
          save = false;
          this.provinciaValida = false;
          this.provinciaInvalidaMsj = 'Debe seleccionar la provincia correspondiente.';
        }

        if ((/true/i).test(this.eventoSolicitaLocalidad)) {
          let errorLocalidad = true;
          if (this.localidad) {
            if (this.localidad.id) {
              if (this.localidad.id != 0) {
                errorLocalidad = false;
              }
            }
          }
          if (errorLocalidad) {
            save = false;
            this.localidadValida = false;
            this.localidadInvalidaMsj = 'Debe seleccionar la localidad correspondiente.';
          }
        }
      }

      if ((/true/i).test(this.eventoParticipacionNegocios)) {
        if ( (/true/i).test(this.eventoRequiereUbicacionNegocio)) {
          let errorPais = true;
          if (this.negocioPais) {
            if (this.negocioPais.id) {
              if (this.negocioPais.id != 0) {
                errorPais = false;
              }
            }
          }
          if (errorPais) {
            save = false;
            this.negocioPaisValido = false;
            this.negocioPaisInvalidoMsj = 'Debe seleccionar el pais correspondiente.';
          }

          let errorProvincia = true;
          if (this.negocioProvincia) {
            if (this.negocioProvincia.id) {
              if (this.negocioProvincia.id != 0) {
                errorProvincia = false;
              }
            }
          }
          if (errorProvincia) {
            save = false;
            this.negocioProvinciaValida = false;
            this.negocioProvinciaInvalidaMsj = 'Debe seleccionar la provincia correspondiente.';
          }

          if ((/true/i).test(this.eventoSolicitaLocalidadNegocio)) {
            let errorLocalidad = true;
            if (this.negocioLocalidad) {
              if (this.negocioLocalidad.id) {
                if (this.negocioLocalidad.id != 0) {
                  errorLocalidad = false;
                }
              }
            }
            if (errorLocalidad) {
              save = false;
              this.negocioLocalidadValida = false;
              this.negocioLocalidadInvalidaMsj = 'Debe seleccionar la localidad correspondiente.';
            }
          }
        }
      }

      if (this.eventoRequiereInformacionBancaria) {
        let errorBanco = true;
        if (this.banco) {
          if (this.banco.id) {
            if (this.banco.id != 0) {
              errorBanco = false;
            }
          }
        }
        if (errorBanco) {
          save = false;
          this.bancoValido = false;
          this.bancoInvalidoMsj = 'Debe seleccionar el banco correspondiente.';
        }
      }

      if (this.$v.$anyError) {
        // console.log(this.$v);
        this.displayErrores();
      } else {
        if (save) {
          let leyenda = 'La información del participante se registró con éxito';
          if (this.id != 0) {
            leyenda = 'Los cambios se registraron con éxito';
          }
          this.showSpinner();
          this.$store.dispatch('participante/save')
            .then(()  => this.showModalMsj(leyenda, this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    objetoValido(objeto, objetoNombre, objetoList, objetoDispatch, validar, 
        objetoValido, objetoInvalidoField, objetoInvalidoMsj) {
      let isValido = true;
      let selected = null;
      if (objetoNombre) {
        selected = this.getSelected(objetoList, objetoNombre);
      }
      this.$store.dispatch('participante/' + objetoDispatch, selected);

      let objetoStore = this.$store.getters['participante/' + objeto];

      if (validar) {
        if (objetoStore) {
          if (objetoStore.id) {
            if (objetoStore.id != 0) {
              isValido = false;
            }
          }
        }
        if (!isValido) {
          objetoValido = false;
          objetoInvalidoField = objetoInvalidoMsj;
        }
      }
      return isValido;
    },
    goList() {
      this.$router.go(-1);
      // this.$router.push({ name: 'Participantes', 
      //                     params: { eventoId: this.eventoId }});
    },
    eventoEtapaActualizado(eventoEtapaNombre) {
      this.eventoEtapaNombre = eventoEtapaNombre;

      let eventoEtapa;
      if (eventoEtapaNombre) {
        eventoEtapa = this.getSelected(this.eventoEtapas, eventoEtapaNombre);
      }
      this.$store.dispatch('participante/setEventoEtapa', eventoEtapa);

      this.eventoEtapaValido = null;
      this.eventoEtapaInvalidoMsj = '';
    },
    generoActualizado(generoNombre) {
      if (!this.loading) {
        this.sexo = generoNombre;

        this.generoValido = null;
        this.generoInvalidoMsj = '';
      }
    },
    bancoActualizado(bancoNombre) {
      if (!this.loadingBancos) {
        this.bancoNombre = bancoNombre;
  
        let banco;
        if (bancoNombre) {
          banco = this.getSelected(this.bancos, bancoNombre);
        }
        this.$store.dispatch('participante/setBanco', banco);
  
        this.bancoValido = null;
        this.bancoInvalidoMsj = '';
      }
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.paisNombre = paisNombre;
        this.provinciaNombre = null;
        this.localidadNombre = null;

        let pais;
        if (paisNombre) {
          pais = this.getSelected(this.paises, paisNombre);
        }

        this.$store.dispatch('participante/setPais', pais)
          .then(() => {
            this.getProvincias();
            this.getLocalidades();
          })
        .catch(error => this.showErrorMsj(error));
        
        this.paisValido = null;
        this.paisInvalidoMsj = '';
      }
    },
    negocioPaisActualizado(paisNombre) {
      if (!this.loadingNegocioPaises) {
        this.negocioPaisNombre = paisNombre;
        this.negocioProvinciaNombre = null;
        this.negocioLocalidadNombre = null;

        let pais;
        if (paisNombre) {
          pais = this.getSelected(this.negocioPaises, paisNombre);
        }
        this.$store.dispatch('participante/setNegocioPais', pais)
          .then(() => {
            this.getNegocioProvincias();
            this.getNegocioLocalidades();
          })
        .catch(error => this.showErrorMsj(error));

        this.negocioPaisValido = null;
        this.negocioPaisInvalidoMsj = '';
      }
    },    
    provinciaActualizada(provinciaNombre) {
      if (!this.loadingProvincias) {
        this.provinciaNombre = provinciaNombre;
        this.localidadNombre = null;

        let provincia;
        if (provinciaNombre) {
          provincia = this.getSelected(this.provincias, provinciaNombre);
        }
        this.$store.dispatch('participante/setProvincia', provincia)
          .then(() => {
            this.getLocalidades();
          })
        .catch(error => this.showErrorMsj(error));

        this.provinciaValida = null;
        this.provinciaInvalidaMsj = '';
      }
    },
    negocioProvinciaActualizada(provinciaNombre) {
      if (!this.loadingNegocioProvincias) {
        this.negocioProvinciaNombre = provinciaNombre;
        this.negocioLocalidadNombre = null;

        let provincia;
        if (provinciaNombre) {
          provincia = this.getSelected(this.negocioProvincias, provinciaNombre);
        }
        this.$store.dispatch('participante/setNegocioProvincia', provincia)
          .then(() => {
            this.getNegocioLocalidades();
          })
        .catch(error => this.showErrorMsj(error));

        this.negocioProvinciaValida = null;
        this.negocioProvinciaInvalidaMsj = '';
      }
    },    
    localidadActualizada(localidadNombre) {
      if (!this.loadingLocalidades) {
        this.localidadNombre = localidadNombre;
  
        let localidad;
        if (localidadNombre) {
          localidad = this.getSelected(this.localidades, localidadNombre);
        }
        this.$store.dispatch('participante/setLocalidad', localidad);
  
        this.localidadValida = null;
        this.localidadInvalidaMsj = '';
      }
    },
    negocioLocalidadActualizada(localidadNombre) {
      // console.log(loadingNegocioLocalidades);
      if (!this.loadingNegocioLocalidades) {
        this.negocioLocalidadNombre = localidadNombre;

        let localidad;
        if (localidadNombre) {
          localidad = this.getSelected(this.negocioLocalidades, localidadNombre);
        }
        this.$store.dispatch('participante/setNegocioLocalidad', localidad);

        this.negocioLocalidadValida = null;
        this.negocioLocalidadInvalidaMsj = '';
      }
    },
    validarCodigoPromocion() {
      this.$store.dispatch('participante/validarCodigoPromocion')
        .then(()  => this.showAlert('El código de promoción ingresado es válido', 'success', null))
        // .then(()  => this.showModalMsj('El código de promoción ingresado es válido', null, null, 'light'))
        .catch(error => this.showAlertError(error));

    },
  },
  watch: {
    'fechaNacimientoHabilitada' : function(newVal, oldVal) {
      this.fechaNacimientoDisabled = !(/true/i).test(this.fechaNacimientoHabilitada);
    },
    'clientePrevio' : function(newVal, oldVal) {
      this.numeroClienteDisabled = !(/true/i).test(this.clientePrevio);
    },
  },
  validations: {
    documentoNumero: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereDocumento);
      }),
      maxLength: maxLength(50)
    },
    nombre: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereNombre);
      }),
      maxLength: maxLength(255)
    },
    apellido: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereNombre);
      }),
      maxLength: maxLength(255)
    },
    sexo: {},
    fechaNacimiento: {},
    prefijo: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereTelefono);
      }),
      numeric
    },
    celular: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereTelefono);
      }),
      numeric
    },
    email: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereEmail);
      }),
      email,
      maxLength: maxLength(255)
    },

    barrio: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereBarrio);
      }),
      maxLength: maxLength(255)
    },
    direccionCalle: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereUbicacion);
      }),
      maxLength: maxLength(255)
    },
    direccionNumero: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereUbicacion);
      }),
      numeric
    },
    codigoPostal: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereUbicacion);
      }),
      maxLength: maxLength(10)
    },

    codigoPromocion: {
      required: requiredIf(function () {
        if ((/true/i).test(this.eventoRequiereCodigoPromocion)) {
          return true;
        }
        return false;
      }),
      maxLength: maxLength(255)
    },

    cbu: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereInformacionBancaria) & this.cbuAlias.trim() == '';
      }),
      maxLength: maxLength(50)
    },
    cbuAlias: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereInformacionBancaria) & this.cbu.trim() == '';
      }),
      maxLength: maxLength(150)
    },
    titularCuenta: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereInformacionBancaria);
      }),
      maxLength: maxLength(255)
    },
    titularCuit: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereInformacionBancaria);
      }),
      maxLength: maxLength(15)
    },

    posicion: {
      required: requiredIf(function () {
        if ((/true/i).test(this.eventoRequierePosicionNegocio)) {
          return true;
        }
        return false;
      }),
      maxLength: maxLength(150)
    },
    nombreComercial: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoParticipacionNegocios);
      }),
      maxLength: maxLength(255)
    },
    razonSocial: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereRazonSocialNegocio);
      }),
      maxLength: maxLength(255)
    },
    cuit: {
      required: requiredIf(function () {
        if ((/true/i).test(this.eventoRequiereDocumentoNegocio)) {
          return true;
        }
        return false;
      }),
      maxLength: maxLength(15)
    },
    negocioBarrio: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereBarrioNegocio);
      }),
      maxLength: maxLength(255)
    },
    negocioDireccionCalle: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereUbicacionNegocio);
      }),
      maxLength: maxLength(255)
    },
    negocioDireccionNumero: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereUbicacionNegocio);
      }),
      numeric
    },
    negocioCodigoPostal: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereUbicacionNegocio);
      }),
      maxLength: maxLength(10)
    },

    numeroCliente: {
      maxLength: maxLength(20)
    },

    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
  .form-abm .grupo-controles input {
    display: inline-block;
  }
  .form-abm .grupo-controles input#prefijo {
    width: Calc(30% - 15px);
  }
  .form-abm .grupo-controles input#celular {
    width: 70%;
    margin-left: 15px;
  }
</style>
